/* eslint-disable no-case-declarations */
import * as types from "./types";

const initialState = {
  form: {
    name: { value: "" },
    mobile: { value: "+84" },
    password: { value: "" },
    repassword: { value: "" }
  },
  infoWillCheckCode: {
    name: "",
    phone: ""
  },
  step: 1,
  otpCode: "",
  // sau khi tách phải giữ lại key này
  currentUrl: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SAVE_FIELD:
      return {
        ...state,
        form: {
          ...state.form,
          ...action.field
        }
      };
    case types.CHANGE_INFO_CHECK_CODE:
      return {
        ...state,
        infoWillCheckCode: action.payload
      };

    case types.CHANGE_STEP:
      let newState;
      switch (action.payload) {
        case 1:
          newState = {
            ...state,
            step: action.payload,
            form: { ...initialState.form }
          };
          break;
        case 2:
        case 5:
          newState = {
            ...state,
            step: action.payload
          };
          break;
        case 3:
        case 4:
          newState = {
            ...state,
            step: action.payload,
            form: {
              ...state.form,
              password: { value: "" },
              repassword: { value: "" }
            }
          };
          break;
        default:
          newState = { ...state };
      }
      return newState;
    case types.RESET_FIELD:
      return {
        ...initialState,
        step: state.step
      };
    case types.GET_DATA_TO_RETYPE_OTP: {
      return {
        ...state,
        form: {
          ...state.form,
          name: { value: state.infoWillCheckCode.name },
          mobile: { value: "84" + state.infoWillCheckCode.phone }
        }
      };
    }

    case types.SET_CURRENT_URL: {
      return {
        ...state,
        currentUrl: action.payload
      };
    }

    default:
      return state;
  }
};
